// Uses the same authenticated axios instance and base URL as the rest of the Parts Tracking app.
import { apiClient } from "../../services/api";

/**
 * Map form fields to backend Athena column names.
 * The form already uses Athena column names, but also supports legacy camelCase aliases.
 */
function toBackendFields(form) {
  return {
    // Athena column names (primary)
    fahrzeugnummer:           form.fahrzeugnummer           ?? form.vehicleNumber,
    projektname:              form.projektname              ?? form.projectName,
    projektnummer:            form.projektnummer            ?? form.projectNumber,
    fahrzeugverantwortlicher: form.fahrzeugverantwortlicher ?? form.vehicleResponsible,
    ba_soll:                  form.ba_soll                  ?? form.desiredDate,
    haertegrad:               form.haertegrad               ?? form.hgStatus ?? "HG0",
    // bau_inkl__ibn comes as "True"/"False" string from the sidebar, or boolean from legacy
    bau_inkl__ibn: typeof form.bau_inkl__ibn === "boolean"
      ? (form.bau_inkl__ibn ? "True" : "False")
      : (form.bau_inkl__ibn ?? "False"),    // Assembly line → aktuelle_station (Athena column)
    aktuelle_station: form.aktuelle_station ?? form.assemblyLine,
    vehicleExists: form.vehicleExists,
    modified_by:   form.modified_by,
  };
}

/** Fetch all vehicles (Athena + local). */
export async function fetchVehicles() {
  const response = await apiClient.get("/vp/vehicles");
  return response.data.vehicles ?? [];
}

/** Fetch a single vehicle by id. */
export async function fetchVehicle(id) {
  const response = await apiClient.get(`/vp/vehicles/${id}`);
  return response.data;
}

/** Create a new vehicle in the backend. */
export async function createVehicle(form) {
  const response = await apiClient.post("/vp/vehicles", toBackendFields(form));
  return response.data;
}

/** Partially update a vehicle (accepts camelCase or snake_case). */
export async function updateVehicle(id, changes) {
  const response = await apiClient.post(`/vp/vehicles/${id}/update`, toBackendFields(changes));
  return response.data;
}

/** Delete a vehicle by id. */
export async function deleteVehicle(id) {
  await apiClient.delete(`/vp/vehicles/${id}`);
  return null;
}

/**
 * Fetch month-wise completed-vehicle counts for the Dashboard chart.
 * Returns an array of 12 objects in Jan->Dec order:
 *   [{ month: "Jan", vehicle_count: 7 }, ...]
 */
export async function fetchVehicleCountByMonth() {
  const response = await apiClient.get("/vp/vehicle-count-by-month");
  return response.data.data ?? [];
}

/**
 * Fetch vehicle counts grouped by highest reached HG stage for the Dashboard.
 * Returns an array of 5 objects in HG0->HG4 order:
 *   [{ hg_stage: "HG0", vehicle_count: 117 }, ...]
 */
export async function fetchVehicleCountByHgStage() {
  const response = await apiClient.get("/vp/vehicle-count-by-hg-stage");
  return response.data.data ?? [];
}

